require('./emitedTransfersContentTableRow.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ core
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');

// @ components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @constants
const { HYPHEN } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');


class EmitedTransfersContentTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.onRowClick = this.onRowClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const { id, emitedTransferDeepLinkResponse, immTransaction } = this.props;
        if(emitedTransferDeepLinkResponse['product'] === immTransaction.getIn(['reference','producto'])
        && emitedTransferDeepLinkResponse['date'] === immTransaction.get('date')
        && emitedTransferDeepLinkResponse['amount'] === immTransaction.getIn(['amount','amount']) ) {
            this.onRowClick(id);
            const element = document.getElementById(id);
            const ROW_HEADER_OFFSET = 250;
            element && window.scrollTo(0, element.offsetTop + ROW_HEADER_OFFSET);
        }
    }

    onRowClick() {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    handleClick(activateLink) {
        this.props.history.push(activateLink);
    }

    buildReuseButton(immTransaction, isExpanded, isMobile, hasDescription) {
        const accountId = immTransaction.get('accountId');
        const transferId = immTransaction.get('id');
        const reusePath = `/myprofile/transfers/transfer/emited-reuse/${accountId}/${transferId}`;
        let reuseButton;

        if (isMobile) {
            if (hasDescription) {
                reuseButton = (
                    <OKButton
                        leftIcon="icon-refrescar"
                        modifier="secondary"
                        to={reusePath}
                    >
                        <FormattedText value="transfersEmited-reUse" />
                    </OKButton>
                );
            } else if (!isExpanded) {
                reuseButton = (
                    <OKIconTask
                        icon="icon-refrescar"
                        onClick={() => this.handleClick(reusePath)}
                        style="default-alternative"
                    />
                );
            }
        } else {
            if (__CONTACT_CENTER__) {
                const reuseIcon = (
                    <div className="emited-transfers-table-row__re-use__icon">
                        <OKIconTask
                            icon="icon-refrescar"
                            onClick={() => this.handleClick(reusePath)}
                            style="default"
                        />
                    </div>
                );
                reuseButton = <OKTooltip type={'interactive'} content={<FormattedText value="transfersEmited-reUse" />} target={reuseIcon} />
            } else {
                reuseButton = (
                    <OKButton
                        modifier="secondary"
                        to={reusePath}
                        size="default"
                    >
                        <FormattedText value="transfersEmited-reUse" />
                    </OKButton>
                );
            }
        }

        return reuseButton;
    }

    render() {
        const {
            id,
            immTransaction,
            immScreen,
            isExpanded
        } = this.props;

        const isMobile = immScreen.get('isMobile')
        const reuseButton = this.buildReuseButton(immTransaction, isExpanded, isMobile, false);
        const beneficiaryClass = classNames('emited-transfers-table-row__beneficiary', {
            'emited-transfers-table-row__beneficiary--highlighted': isExpanded
        });
        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const language = getLanguage();

        let tableRow;
        let dateCell = (
            <LabelDate
                date={immTransaction.get('date')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );
        let amountCell = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );

        if (isMobile) {
            const reuseButtonExpandedMobile = this.buildReuseButton(immTransaction, isExpanded, isMobile, true);
            const mobileDetailNoMargin = classNames(
                "emited-transfers-table-row__detail-mobile",
                "emited-transfers-table-row__detail-mobile--no-margin"
            );
            const mobileReuseButton = classNames(
                "emited-transfers-table-row__re-use",
                "emited-transfers-table-row__re-use--mobile"
            );

            tableRow = (
                <React.Fragment>
                    <OKTableRow id={id} isExpanded={isExpanded}>
                        <OKTableCell className="emited-transfers-table-row__expand">
                            <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                        </OKTableCell>
                        <OKTableCell>
                            <p className="emited-transfers-table-row__detail-mobile">
                                {dateCell}
                            </p>
                            <p className={mobileDetailNoMargin}>
                                {immTransaction.get('beneficiaryName')}
                            </p>
                            <p className={mobileDetailNoMargin}>
                                {amountCell}
                            </p>
                        </OKTableCell>
                        <OKTableCell className={mobileReuseButton}>
                            {reuseButton}
                        </OKTableCell>
                    </OKTableRow>
                    { isExpanded && <OKTableRow isExpanded={isExpanded}>
                        <OKTableCell />
                        <OKTableCell colSpan={2}>
                            {reuseButtonExpandedMobile}
                        </OKTableCell>
                    </OKTableRow> }
                </React.Fragment>
            );
        } else {
            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell className="emited-transfers-table-row__expand">
                        <OKCollapsingToggler handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={!__CONTACT_CENTER__} />
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-table-row__date">
                        {dateCell}
                    </OKTableCell>
                    <OKTableCell className={beneficiaryClass}>
                        {immTransaction.get('beneficiaryName')}
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-table-row__concept">
                        {immTransaction.get('concept') || HYPHEN}
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-table-row__amount">
                        {amountCell}
                    </OKTableCell>
                    <OKTableCell className="emited-transfers-table-row__re-use">
                        {reuseButton}
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

EmitedTransfersContentTableRow.propTypes = {
    history: PropTypes.object.isRequired,
    emitedTransferDeepLinkResponse: PropTypes.object,
    id: PropTypes.string.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
};

EmitedTransfersContentTableRow.defaultProps = {
    onRowClick: function () { }
};

module.exports.constructor = EmitedTransfersContentTableRow;
module.exports = connect(
    state => ({
        emitedTransferDeepLinkResponse: state.personeticsDeepLinks.get('emitedTransferMovementRequest').toJS(),
        immScreen: state.screen,
    }),
    null)(withRouter(EmitedTransfersContentTableRow));
